
import {
  Box,
  Flex
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export type FooterButtonLayoutProps = {
  children: ReactNode;
}

export const FooterButtonLayout = ({
  children
}: FooterButtonLayoutProps) => {
  return (
    <Box
      py={4}
      bg={'rgba(255,255,255,0.4)'}
      css={{
        backdropFilter: 'blur(15px)',
      }}
      textAlign={'center'}
      boxShadow={'0px -2px 16px rgb(0 0 0 / 14%)'}
    >
      <Flex
        alignItems={'center'}
        justifyContent={'space-between'}
        w={'95%'}
        mx={'auto'}
      >
        {children}
      </Flex>
    </Box>
  );
};
